import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, Observable, map, switchMap, catchError, tap } from 'rxjs';
import { submitOrderFailed, submitOrderSuccess, hideOrderStateInlineLoader, paymentError, activeClaims } from '../_actions/order.actions'
import * as ActionConfigurationManager from '.././_actions/config.actions';
import { Action, Store } from '@ngrx/store';
import { PaymentService } from '../_services/payment-and-tax-service.service';
import { Router } from '@angular/router';
import { loadConfirmationNumber } from '../_actions/confirmation.actions';
import { ConfirmationNumber, PurchaseContractResponse } from '../_models/confirmation';
import { Injectable } from '@angular/core';
import { LoggingService } from '../_services/logging.service';
import { clearCart } from '../_actions/cart.actions';
import { maskPurchaseContractResponse } from '../_services/payment-mask.util';

function isCvvVerificationError(error: any): boolean {
  const msg = error?.error?.message ?? error?.error?.errorMessage ?? '';
  if (typeof msg !== 'string') return false;
  const lower = msg.toLowerCase();
  return (
    lower.includes('cvv') ||
    lower.includes('cvc') ||
    // Zuora can return validation wording like: "'securityCode' should be a 3- or 4-digit number."
    lower.includes('securitycode') ||
    lower.includes('security code') ||
    lower.includes('3- or 4-digit') ||
    lower.includes('3 or 4-digit')
  );
}

@Injectable()

export class OrderEffects {

  public saveOrderAccount$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(ActionConfigurationManager.SUBMIT_ORDER_ACCOUNT_FLOW),
            switchMap((action: any) => this.orderService.purchaseContractAccount(action)
                .pipe(
                    tap((order: PurchaseContractResponse) => {
                      const maskedResponse = maskPurchaseContractResponse(order);
                    }),
                    map((order: PurchaseContractResponse) => {
                      console.log(order);
                      console.log('hi')

                      let request: ConfirmationNumber = {
                          confirmationNumber: order.data[0].orderId,
                          viewContractId: order.data[0].viewContractId,
                          contractId: order.data[0].contractId,
                          productCategory: order.data[0].productCategory,
                          contracts: order.data // Store all contracts for future use
                      }

                      this.store.dispatch(loadConfirmationNumber(request))
                      this.store.dispatch(hideOrderStateInlineLoader())
                      this.router.navigate(['/checkout/confirmation']);
                      return submitOrderSuccess()
                      // if (order.data === null) {
                      //   this.store.dispatch(hideOrderStateInlineLoader())
                      //   return submitOrderFailed()
                      // } else if (order.data.payment === false) {
                      //   this.store.dispatch(hideOrderStateInlineLoader())
                      //   return paymentError()
                      // } else {
                      //   this.store.dispatch(loadConfirmationNumber(request))
                      //   this.store.dispatch(hideOrderStateInlineLoader())
                      //   this.router.navigate(['/checkout/confirmation']);
                      //   return submitOrderSuccess()
                      // }
                    }),
                    catchError((error) => this.handleOrderPaymentError(error)),

                )
            )
        )
    )

    public saveOrderGuest$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(ActionConfigurationManager.SUBMIT_ORDER_GUEST_FLOW),
            switchMap((action: any) => this.orderService.purchaseContractGuest(action)
                .pipe(
                    tap((order: PurchaseContractResponse) => {
                      const maskedResponse = maskPurchaseContractResponse(order);
                    }),
                    map((order: PurchaseContractResponse) => {
                      console.log('saveOrderGuest$', order)

                      let request: ConfirmationNumber = {
                          confirmationNumber: order.data[0].orderId,
                          viewContractId: order.data[0].viewContractId,
                          contractId: order.data[0].contractId,
                          productCategory: order.data[0].productCategory,
                          access_token: order.data[0].access_token,
                          contracts: order.data // Store all contracts for future use
                      }
                      sessionStorage.setItem('tokenId', order.data[0].access_token)
                      // deleting traces of paypal after successfull purchase if it was done via paypal
                      this.store.dispatch(loadConfirmationNumber(request))
                      this.store.dispatch(hideOrderStateInlineLoader())
                      this.router.navigate(['/checkout/confirmation']);
                      const keysToDelete = ['paypalPickedAsOption', 'paypalIdToken'];
                      keysToDelete.forEach(key => {
                        if (sessionStorage.getItem(key)) {
                            sessionStorage.removeItem(key);
                        }
                      });


                      this.store.dispatch(clearCart());
                      return submitOrderSuccess()

                    }),
                    catchError((error) => {
                      // Guest-only: 530 returns order data in error body; treat as success.
                      if (error?.status === 530 && error?.error?.data?.[0]) {
                        console.log('530 returned', error.error.data);
                        this.store.dispatch(hideOrderStateInlineLoader());
                        const request: ConfirmationNumber = {
                          confirmationNumber: error.error.data[0].orderId,
                          viewContractId: error.error.data[0].viewContractId,
                          contractId: error.error.data[0].contractId,
                          productCategory: error.error.data[0].productCategory,
                          access_token: error.error.data[0].access_token,
                          contracts: error.error.data,
                        };
                        sessionStorage.setItem('tokenId', error.error.data[0].access_token);
                        this.store.dispatch(loadConfirmationNumber(request));
                        this.router.navigate(['/checkout/confirmation']);
                        const keysToDelete = ['paypalPickedAsOption', 'paypalIdToken'];
                        keysToDelete.forEach((key) => {
                          if (sessionStorage.getItem(key)) {
                            sessionStorage.removeItem(key);
                          }
                        });
                        this.store.dispatch(clearCart());
                        this.store.dispatch(submitOrderSuccess());
                        return EMPTY;
                      }
                      return this.handleOrderPaymentError(error);
                    }),
                )
            )
        )
    )

    public saveOrderChangeVehicle$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(ActionConfigurationManager.SUBMIT_ORDER_CHANGE_VEHICLE_FLOW),
            switchMap((action: any) => this.orderService.purchaseContractChange(action)
                .pipe(
                    tap((order: PurchaseContractResponse) => {
                      const maskedResponse = maskPurchaseContractResponse(order);
                    }),
                    map((order: PurchaseContractResponse) => {
                      console.log(order);
                      console.log('hi')

                      let request: ConfirmationNumber = {
                          confirmationNumber: order.data[0].orderId,
                          viewContractId: order.data[0].viewContractId,
                          contractId: order.data[0].contractId,
                          productCategory: order.data[0].productCategory,
                          contracts: order.data // Store all contracts for future use
                      }

                      this.store.dispatch(loadConfirmationNumber(request))
                      this.store.dispatch(hideOrderStateInlineLoader())
                      this.router.navigate(['/checkout/confirmation']);
                      return submitOrderSuccess()
                      // if (order.data === null) {
                      //   this.store.dispatch(hideOrderStateInlineLoader())
                      //   return submitOrderFailed()
                      // } else if (order.data.payment === false) {
                      //   this.store.dispatch(hideOrderStateInlineLoader())
                      //   return paymentError()
                      // } else {
                      //   this.store.dispatch(loadConfirmationNumber(request))
                      //   this.store.dispatch(hideOrderStateInlineLoader())
                      //   this.router.navigate(['/checkout/confirmation']);
                      //   return submitOrderSuccess()
                      // }
                    }),
                    catchError((error) => this.handleOrderPaymentError(error)),
                )
            )
        )
    )

    public saveOrderChangeAccount$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(ActionConfigurationManager.SUBMIT_ORDER_CHANGE_ACCOUNT_FLOW),

            switchMap((action: any) => this.orderService.purchaseContractChange(action)
                .pipe(
                    tap((order: PurchaseContractResponse) => {
                      const maskedResponse = maskPurchaseContractResponse(order);
                    }),
                    map((order: PurchaseContractResponse) => {
                      console.log(order);
                      console.log('hi')

                      let request: ConfirmationNumber = {
                          confirmationNumber: order.data[0].orderId,
                          viewContractId: order.data[0].viewContractId,
                          contractId: order.data[0].contractId,
                          productCategory: order.data[0].productCategory,
                          contracts: order.data // Store all contracts for future use
                      }
                      this.store.dispatch(loadConfirmationNumber(request))
                      this.store.dispatch(hideOrderStateInlineLoader())
                      this.router.navigate(['/checkout/confirmation']);
                      return submitOrderSuccess()
                    }),
                    catchError((error) => this.handleOrderPaymentError(error)),
                )
            )
        )
    )

    /**
     * Shared payment error handler: logs, hides loader, dispatches by status (CVV / 525 / 527 / default),
     * reports to D2C capture, and returns EMPTY. Use in saveOrder* effects for consistent behavior.
     */
    private handleOrderPaymentError(error: unknown): Observable<never> {
        const status = (error as any)?.status;
        const message =
            (error as any)?.error?.message ?? (error as any)?.error?.errorMessage ?? (error as any)?.message;
        this.store.dispatch(hideOrderStateInlineLoader());
        if (status === 527) {
            this.store.dispatch(activeClaims());
        } else if (status === 525) {
            this.store.dispatch(
                isCvvVerificationError(error)
                    ? paymentError({ paymentErrorType: 'cvv' })
                    : paymentError({})
            );
        } else {
            this.store.dispatch(submitOrderFailed());
        }
        this.loggingService.handleErrorWithD2CCapture(error, 'high', 'payment');
        return EMPTY;
    }

    constructor(
        private actions$: Actions,
        private store: Store<{}>,
        private router: Router,
        private orderService: PaymentService,
        private loggingService: LoggingService
    ) {}
}
